import MatrixTextField from "../../components/content/singlePage/MatrixTextField";
import MatrixButtonField from "../../components/content/singlePage/MatrixButtonField";
import MatrixBannerField from "../../components/content/singlePage/MatrixBannerField";
import MatrixDoubleImageField from "../../components/content/singlePage/MatrixDoubleImageField";
import MatrixTextWithImageField from "../../components/content/singlePage/MatrixTextWithImageField";
import MatrixVideoField from "../../components/content/singlePage/MatrixVideoField";

export default function PageContent({pageData, noOlafGrid = false}) {
    const content = () => {
        if (pageData?.blocks) {
            return pageData?.blocks.map((block, i) => {
                switch (block.type) {
                    case 'tekstVeld':
                        return MatrixTextField(block, i);
                    case 'knopVeld':
                        return MatrixButtonField(block, i);
                    case 'bannerVeld':
                        return MatrixBannerField(block, i);
                    case 'dubbeleFotoVeld':
                        return MatrixDoubleImageField(block, i);
                    case 'tekstMetFotoVeld':
                        return MatrixTextWithImageField(block, i);
                    case 'videoVeld':
                        return MatrixVideoField(block, i);
                }
            });
        }
    }

    return (
        <div className={`${noOlafGrid ? '' : 'olafGrid'}`}>
            {content()}
        </div>
    );
}
